"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _styles = require("@material-ui/core/styles");
var _lodash = require("lodash");
var _excluded = ["aria-label", "children", "classes", "color", "dataMetrics", "disableHover", "size"],
  _excluded2 = ["root", "colorPrimary", "colorSecondary", "focusVisible"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var focusVisibleClasses = {
    color: {
      primary: {
        border: "2px solid ".concat(theme.palette.white)
      },
      secondary: {
        border: "2px solid ".concat(theme.palette.white),
        color: theme.palette.white
      }
    },
    dark: {
      primary: {
        border: "2px solid ".concat(theme.palette.primary[200])
      },
      secondary: {
        border: "2px solid ".concat(theme.palette.white),
        color: theme.palette.white
      }
    },
    light: {
      primary: {
        border: "2px solid ".concat(theme.palette.primary[800])
      },
      secondary: {
        border: "2px solid ".concat(theme.palette.opacity.black[87])
      }
    }
  };
  return {
    colorPrimary: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    colorSecondary: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    focusVisible: function focusVisible(_ref) {
      var color = _ref.color;
      return _objectSpread({
        borderRadius: '50%'
      }, focusVisibleClasses[theme.themeType][color]);
    },
    root: {
      '& svg': {
        height: function height(_ref2) {
          var svgSize = _ref2.svgSize;
          return svgSize;
        },
        width: function width(_ref3) {
          var svgSize = _ref3.svgSize;
          return svgSize;
        }
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref4) {
          var disableHover = _ref4.disableHover;
          return disableHover ? 'transparent' : null;
        }
      },
      height: function height(_ref5) {
        var buttonSize = _ref5.buttonSize;
        return buttonSize;
      },
      width: function width(_ref6) {
        var buttonSize = _ref6.buttonSize;
        return buttonSize;
      }
    }
  };
});
var defaultProps = {
  color: 'primary',
  dataMetrics: {
    root: 'fuse_icon_button'
  },
  disabled: false,
  disableFocusRipple: false,
  disableHover: false,
  edge: false,
  size: 'medium'
};

/**
 * IconButton can be used individually, or as part of other components/patterns. For instance, text field, text area, dialog, side panel, etc.
 */
var IconButton = /*#__PURE__*/_react["default"].forwardRef(function (_ref7, ref) {
  var _cx, _cx2;
  var ariaLabel = _ref7['aria-label'],
    children = _ref7.children,
    _ref7$classes = _ref7.classes,
    classes = _ref7$classes === void 0 ? {} : _ref7$classes,
    color = _ref7.color,
    dataMetrics = _ref7.dataMetrics,
    disableHover = _ref7.disableHover,
    size = _ref7.size,
    props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded);
  var classesRoot = classes.root,
    classesColorPrimary = classes.colorPrimary,
    classesColorSecondary = classes.colorSecondary,
    classesFocusVisible = classes.focusVisible,
    restClasses = (0, _objectWithoutProperties2["default"])(classes, _excluded2);
  var iconSizeMap = {
    medium: {
      inherit: 40,
      primary: 40,
      secondary: 40,
      svg: 24
    },
    small: {
      inherit: 24,
      primary: 24,
      secondary: 24,
      svg: 16
    }
  };
  var svgSize = (0, _lodash.get)(iconSizeMap, "".concat(size, ".svg"), iconSizeMap.medium.svg);
  var buttonSize = (0, _lodash.get)(iconSizeMap, "".concat(size, ".").concat(color), iconSizeMap.medium.primary);
  var internalClasses = useStyles({
    buttonSize: buttonSize,
    color: color,
    disableHover: disableHover,
    svgSize: svgSize
  });
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);

  // ACCESSIBILITY
  var iconName = children && children.type && children.type.displayName ? children.type.displayName : '';
  var discernableButtonText = ariaLabel || iconName;
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    "aria-label": discernableButtonText,
    color: color,
    classes: _objectSpread({
      colorPrimary: (0, _classnames["default"])((_cx = {}, (0, _defineProperty2["default"])(_cx, internalClasses.colorPrimary, disableHover), (0, _defineProperty2["default"])(_cx, classesColorPrimary, !!classesColorPrimary), _cx)),
      colorSecondary: (0, _classnames["default"])((_cx2 = {}, (0, _defineProperty2["default"])(_cx2, internalClasses.colorSecondary, disableHover), (0, _defineProperty2["default"])(_cx2, classesColorSecondary, !!classesColorSecondary), _cx2)),
      root: (0, _classnames["default"])(internalClasses.root, (0, _defineProperty2["default"])({}, classesRoot, !!classesRoot))
    }, restClasses),
    "data-metrics": mergedDataMetrics.root,
    ref: ref,
    focusVisibleClassName: internalClasses.focusVisible
  }, props), children);
});
IconButton.defaultProps = defaultProps;
IconButton.displayName = 'IconButton';
IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * **Highly Recommended** for accessibility compliance.
   */
  'aria-label': _propTypes["default"].string,
  /**
   * The icon element.
   */
  children: _propTypes["default"].node,
  /**
   * @ignore
   */
  classes: _propTypes["default"].object,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['inherit', 'primary', 'secondary']),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true` the button will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If `true` the keyboard focus ripple will be disabled. disableRipple must also be true.
   */
  disableFocusRipple: _propTypes["default"].bool,
  /**
   * If `true` the button hover state will be disabled, but the button will still be active.
   */
  disableHover: _propTypes["default"].bool,
  /**
   * If `true` the ripple effect will be disabled.
   */
  disableRipple: _propTypes["default"].bool,
  /**
   * If given, uses a negative margin to counteract the padding on one side (this is often helpful for aligning the left or right side of the icon with content above or below, without ruining the border size and shape).
   */
  edge: _propTypes["default"].oneOf(['start', 'end', false]),
  /**
   * The size of the button. `small` is equivalent to the dense button styling.
   */
  size: _propTypes["default"].oneOf(['small', 'medium'])
} : {};
var _default = IconButton;
exports["default"] = _default;